import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import {
  SavePortfolioAssetsVars,
  SavedPortfolioAssetsData
} from '../../dashboard/gql-types';

import ApolloClientService from '../../shared/services/ApolloClientService';
import Config from '../../shared/config';
import DashboardGraphQL from '../gql';

let dashboardApolloClient: ApolloClient<NormalizedCacheObject> = null;

export function useScrollPosition(
  userkey: number,
  lessonkey: number,
  layer: number
) {
  if (!dashboardApolloClient) {
    dashboardApolloClient = ApolloClientService.create(Config.DASHBOARD_GQL);
  }

  const updateScrollPosition = (componentkey: number) => {
    return dashboardApolloClient.mutate<
      SavedPortfolioAssetsData,
      SavePortfolioAssetsVars
    >({
      mutation: DashboardGraphQL.Mutation.UPDATE_SCROLL_POSITION,
      variables: {
        userkey,
        modulekey: lessonkey,
        layer,
        componentkey
      }
    });
  };

  return {
    updateScrollPosition
  };
}
